import React from "react";
import l from "components/util/l";
import Chat from "components/tmisc/chat/Chat";
import "styles/css/presentation/Assistant.css";

const AssistantView = ({ flow, processName, onClose }) => (
  <div id="presentation-assistant" className="d-flex flex-column" data-testid="presentation-assistant">

    <div className="assistant-header d-flex align-items-center justify-content-between">
      <span className="font-weight-bold">
        <i className="fas fa-question-circle mr-2"></i>{l("Asistente%SA305")}
      </span>
      <button
        type="button"
        className="btn btn-sm btn-link p-0"
        title={l("Cerrar%GA089")}
        data-testid="presentation-assistant-close"
        onClick={onClose}
      >
        <i className="fas fa-times"></i>
      </button>
    </div>

    <div className="flex-fill overflow-hidden chat-light-panel">
      <Chat
        flow={flow}
        freshChat={true}
        slotId="presentation-assistant"
        autoRunProcessName={processName}
        showScreenshotAttachment={true}
      />
    </div>

  </div>
);

export default AssistantView;
